import axios from 'axios';
import {config} from '../config';

export const adminAction = (
    actionType,
    id,
    operatorId
) => {

    const adminRequestParameters = {
        method: 'post',
        headers: {
            Authorization: 'bearer ' + localStorage.tokens,
            'Content-Type': 'application/json',
        },
        url: `${config.endpoint}/v1/terminal/${id}/administration`,
        data: { 'action': actionType ,'operatorId':operatorId},
    };
    return axios(adminRequestParameters)
        .then((res) => {return res;})
        .catch(err => {return err;} 
        );
};

// import axios from "axios";
// import config from '../config.json';

// export const adminAction = (
//     actionType,
//     id
// ) => {

//     const adminRequestParameters = {
//         method: "post",
//         headers: {
//             Authorization: "bearer " + localStorage.tokens,
//             "Content-Type": "application/json",
//         },
//         url: `${config.endpoint}/v1/terminal/${id}/administration`,
//         data: { "action": actionType },
//     };
//     return axios(adminRequestParameters)
//         .then((res) => res)
//         .catch(err => {
//             !Object.keys(err.response.data.failure).length ?
//             alert('Oops.. Something went Wrong !'):
//             alert(err.response.data.failure);
//         });
// };